import {createSlice} from "@reduxjs/toolkit";
import {FAILED, LOADING, SUCCESS} from "../../common/statuses";
import {getTrainingHistory, TRAINING} from "./trainingService";
import {initialState} from "./initState";

const trainingReducer = createSlice({
    name: TRAINING,
    initialState,
    reducers: {
        clearTrainingState: () => {
            return {...initialState}
        }
    },
    extraReducers(builder) {
        builder
            .addCase(getTrainingHistory.pending, ({tasks}) => {
                tasks.status = LOADING
            })
            .addCase(getTrainingHistory.fulfilled, ({tasks}, action) => {
                tasks.status = SUCCESS
                tasks.mental = action.payload
            })
            .addCase(getTrainingHistory.rejected, ({tasks}) => {
                tasks.status = FAILED
            })
    }
})

export const {clearTrainingState} = trainingReducer.actions;

export default trainingReducer.reducer;
